"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var HangTight = function (_a) {
    var type = _a.type, className = _a.className, _b = _a.paused, paused = _b === void 0 ? false : _b, other = __rest(_a, ["type", "className", "paused"]);
    return (react_1["default"].createElement("div", __assign({ className: classnames_1["default"]("hang-tight__" + type, className, {
            'hang-tight--paused': paused
        }), role: "progressbar", "aria-valuetext": "Loading", "aria-busy": "true", "aria-valuemin": 0, "aria-valuemax": 100 }, other)));
};
exports["default"] = HangTight;
